import { AxiosInstance, AxiosRequestConfig } from 'axios';

import {
  SearchEquipsLocations,
  SearchGoodBadPoints,
  SearchTempOutlets,
  SearchVisitOutlets,
} from './types';
const ENDPOINT = 'map/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getOutlets: (payload: SearchGoodBadPoints) =>
    instance.post(ENDPOINT + 'good_bad_points/', payload, config),
  getTempOutlets: (payload: SearchTempOutlets) =>
    instance.post(ENDPOINT + 'base_points/', payload, config),
  getVisitOutlets: (payload: SearchVisitOutlets) =>
    instance.post(ENDPOINT + 'visit_outlets/', payload, config),
  getEquipmentsLocations: (payload: SearchEquipsLocations) =>
    instance.post(ENDPOINT + 'equips_locations/', payload, config),
});
